"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameTagContainer = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
exports.NameTagContainer = react_1.default.memo(({ test_type, member_name }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [memberName, setMemberName] = react_1.default.useState(member_name);
    const [subjectName, setSubjectName] = react_1.default.useState('');
    (0, react_1.useEffect)(() => {
        setSubjectName(test_type);
    }, [test_type]);
    (0, react_1.useEffect)(() => {
        setMemberName(member_name);
    }, [member_name]);
    return (react_1.default.createElement("div", { className: `${isMobile ? 'name-tag-info' : 'field-short'}`, style: { gap: isDesktop && '24px' } },
        react_1.default.createElement("div", { className: "field-global-001", style: { width: isMobile ? '100%' : '80%' } },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.subjectType')),
            react_1.default.createElement("div", { className: "fext-field", style: { flexDirection: 'column', alignItems: 'flex-start' } },
                react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, value: subjectName }))),
        memberName && (react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label", style: { justifyContent: 'flex-start' } }, t('assignment.submittedBy')),
            react_1.default.createElement("div", { className: "fext-field", style: { flexDirection: 'column', alignItems: 'flex-start' } },
                react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, value: memberName }))))));
});
